export enum EditModeState {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  Canceled = 'Canceled',
  Saved = 'Saved',
  SaveError = 'SaveError',
}
